<template>
  <div class="header zpa-row">

    <zpa-row class="logo" center middle width="350px">
      <img @click="showMsg" src="../../assets/logo2.png" />
      <!--创业创新服务平台-->
    </zpa-row>

    <zpa-row end middle>
      <Message v-model="isUnRead" style="margin-right: 20px" @changetype="changetype">

      </Message>
      <span v-if="isUnRead === '1'" style="color: white;
            margin-left: -31px;
            margin-top: -22px;
            margin-right: 25px;
            background: red;
            width: 8px;
            height: 8px;
            border-radius: 4px;
            text-align: center;
            line-height: 25px;">

      </span>

      <slot></slot>
    </zpa-row>

  </div>
</template>

<script>
import { login, getCurrposition } from '@/api/login';
import { haveNeverRead } from '@/api/fwsc/yearfee'
import Message from '@/components/commons/Message'
export default {
  name: 'Header',

  data() {
    return {
      isUnRead: ''
    }
  },

  components: {
    Message
  },

  methods: {
    showMsg() {
      getCurrposition().then(position => {
        this.$store.state.currentUser = position
        this.$centitIM({
          userCode: position.userCode,
          userName: position.userName
        })
      })
    },
    changetype() {
      console.log('信息查询')
      haveNeverRead().then(res => {
        console.log(res)
        this.isUnRead = res
      })
    }
  },

  mounted() {
    this.changetype()
  }

}
</script>

<style scoped lang="less">
.header {
  background-color: #cda337;
}
</style>
